import React from 'react';

const FormSearchEngine = ({ searchKeyword, onSearchChange, onSearch, onKeyDown }) => {
    return (
        <div className="input-group">
            <input
                type="text"
                className="form-control"
                placeholder="폼 제목으로 검색"
                value={searchKeyword}
                onChange={(e) => onSearchChange(e.target.value)}
                onKeyDown={onKeyDown}
            />
            <button
                className="btn btn-primary"
                type="button"
                onClick={onSearch}
            >
                검색
            </button>
        </div>
    );
};

export default FormSearchEngine;
